import React, { useMemo } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { TicketIcon } from "@heroicons/react/24/solid";
import { CSVLink } from "react-csv";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import DownloadButton from "../../../../components/DownloadButton";
import useGetAllMappedToKeeper from "./hooks/useGetAllMappedToKeeper";
import { useHistory } from "react-router-dom";
import { mainSelectedTab } from "../../atoms";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { CarrierAgreementMgmtTabs } from "../../carrierAgreementTabs";
import { IKeeperExceptionReport } from "./types";

interface KeeperExceptionReportProps {}
export const KeeperExceptionReport: React.FC<
  KeeperExceptionReportProps
> = () => {
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);

  const { data: mappedToKeeperdata, isLoading: mappedToKeeperdataLoading } =
    useGetAllMappedToKeeper();

  const mappedToKeeperRecords = mappedToKeeperdata?.filter((x) => {
    return x.mappedToKeeper === true;
  });
  function percentage(partialValue, totalValue) {
    return (100 * partialValue) / totalValue;
  }
  //For downloading table data
  const exportdata = useMemo(
    () =>
      mappedToKeeperdata?.map((data: IKeeperExceptionReport) => ({
        CarrierName: data.carrierName,
        ProducerCode: data.producerCode,
        ProducerSubCode: data.producerSubCode,
        LineOfBusiness: data.lineOfBusiness,
        States: data.state,
        OfficeCode: data.officeCode,
        StoreNumber: data.storeNumber,
        "Office Name": data.officeName,
        ProgramName: data.program,
        MGA: data.mga,
        DistributionChannelName: data.distributionChannelName,
        IsActive: data.status,
        MappedToKeeper: data.keeper,
      })) ?? [],
    [mappedToKeeperdata]
  );

  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
  const csvReport = {
    filename: "KeeperExceptionReport_" + dateTimeToday + ".csv",
    data: exportdata ? exportdata : [],
  };

  const officeColumns = [
    { title: "CarrierName", field: "carrierName" },
    { title: "ProducerCode", field: "producerCode" },
    { title: "ProducerSubCode", field: "producerSubCode" },
    { title: "LineOfBusiness", field: "lineOfBusiness" },
    { title: "States", field: "state" },
    { title: "OfficeCode", field: "officeCode" },
    { title: "StoreNumber", field: "storeNumber" },
    {
      title: "Office Name",
      field: "officeName",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/officesettings/officesetting";
              history.push({
                pathname: url,
                state: {
                  pathname: url,
                  officeCode: rowData?.officeCode,
                  action: "mappedtokeeperreport",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...CarrierAgreementMgmtTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
            }}
          >
            <span className="text-quinary  font-bold underline text-sm ">
              {rowData.officeName}
            </span>
          </div>
        );
      },
    },
    { title: "ProgramName", field: "program" },
    { title: "MGA", field: "mga" },
    { title: "DistributionChannelName", field: "distributionChannelName" },
    { title: "isActive", field: "status" },
    {
      title: "MappedToKeeper",
      field: "keeper",
    },
  ];

  return (
    <div className="text-xs items-center">
      <div className="">
        <div className="mx-4 mt-4 overflow-x-auto">
          <div className="flex mb-2 gap-2 items-center">
            <div>
              <TicketIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading-tight">
              <div className="text-gray-500 text-md font-medium">
                Report: Producer Codes
              </div>
              <div className="flex items-center font-bold text-lg text-primary">
                {"Keeper Exception Report"}
              </div>
            </div>
          </div>
          <div className="mt-2" />
          <div className="flex justify-between mb-2 mr-2">
            <div className="flex items-center gap-1">
              <span className="text-gray-500 text-sm">
                Total Mapped Records:{" "}
              </span>
              <span className="text-primary text-base font-semibold">
                {mappedToKeeperdata
                  ? (
                      Math.round(
                        percentage(
                          mappedToKeeperRecords?.length,
                          mappedToKeeperdata.length
                        ) * 100
                      ) / 100
                    ).toFixed(2)
                  : 0}
                %:{" "}
              </span>

              <span className="text-reportsColor text-base font-semibold">
                {mappedToKeeperRecords?.length} out of{" "}
                {mappedToKeeperdata?.length}
              </span>
            </div>
            <CSVLink {...csvReport}>
              <DownloadButton buttonValue="Download File" onClick={() => {}} />
            </CSVLink>
          </div>
        </div>
        <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
          <MaterialTableTS
            data={mappedToKeeperdata}
            isLoading={mappedToKeeperdataLoading}
            columns={officeColumns}
            showTitle={false}
            toolbarSearch={true}
            showToolbar={true}
          />
        </div>
      </div>
    </div>
  );
};
